import { useInvoiceAssistant } from '../assistant/useInvoiceAssistant';
import { useInvoiceFlow } from './useInvoiceFlow';

/** Qué herramientas tocan: el asistente y el switch de prueba, cada uno detrás de su bandera. */
export const useInvoiceTools = (showEmissionMode = true) => {
  const assistant = useInvoiceAssistant();
  const { canChooseEmissionMode } = useInvoiceFlow();
  const withEmissionMode = showEmissionMode && canChooseEmissionMode;
  return { withEmissionMode, any: Boolean(assistant) || withEmissionMode };
};
